import { BULLION_PRODUCT } from "@/app/alts/bullion/type-constants";
import type { BULLION_KEY } from "@/app/alts/bullion/type-constants";

interface AssetInformationTitleProps {
    product: BULLION_KEY;
}

export default function AssetInformationTitle({ product }: AssetInformationTitleProps) {
    const title =
        BULLION_PRODUCT[product].TYPE === BULLION_PRODUCT.GOLD.TYPE
            ? "24K, 999.9+ purity Gold Rate"
            : BULLION_PRODUCT[product].TYPE === BULLION_PRODUCT.SILVER.TYPE
              ? "Pure Digital Silver"
              : null;

    if (!title) return null;

    return (
        <h1 className="section-chart-title text-4xl font-semibold leading-[130%] tracking-[-0.48px] text-neutral-900">
            {title}
        </h1>
    );
}
